import { useFlags } from 'launchdarkly-react-client-sdk';
import { LAUNCHDARKLY_TOGGLES } from '@studio/constants/launchdarkly-toggle-constants';

/**
 * This will have more checks in the future related to the plan and user entitlements.
 */
const useIsMultiUpload = (): boolean => {
  const { [LAUNCHDARKLY_TOGGLES.MULTI_UPLOAD_FLOW]: multiUploadFlow } = useFlags();

  return Boolean(multiUploadFlow);
};

export default useIsMultiUpload;
